import { AnalyticsEvent, Maybe } from '@varo/graphql-schema-types';
import React, {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

interface SelfFundedOfferAnalytics {
  display?: Maybe<AnalyticsEvent>;
  cta?: Maybe<AnalyticsEvent>;
}

interface SelfFundedOfferContextProps {
  analytics: SelfFundedOfferAnalytics;
  setDisplayAnalytics: (source: Maybe<AnalyticsEvent>) => void;
  setCtaAnalytics: (source: Maybe<AnalyticsEvent>) => void;
}

const SelfFundedOfferContext = createContext<SelfFundedOfferContextProps>({
  analytics: {},
  setDisplayAnalytics: () => {},
  setCtaAnalytics: () => {},
});

export const SelfFundedOfferContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [analytics, setAnalytics] = useState<SelfFundedOfferAnalytics>({});

  const setDisplayAnalytics = useCallback(
    (displayEvent: Maybe<AnalyticsEvent>) => {
      setAnalytics((prev) => ({ ...prev, display: displayEvent }));
    },
    [],
  );

  const setCtaAnalytics = useCallback((ctaEvent: Maybe<AnalyticsEvent>) => {
    setAnalytics((prev) => ({ ...prev, cta: ctaEvent }));
  }, []);

  const contextValue = useMemo(
    () => ({
      analytics,
      setDisplayAnalytics,
      setCtaAnalytics,
    }),
    [analytics, setDisplayAnalytics, setCtaAnalytics],
  );

  return (
    <SelfFundedOfferContext.Provider value={contextValue}>
      {children}
    </SelfFundedOfferContext.Provider>
  );
};

export const useSelfFundedOffer = () => {
  return useContext(SelfFundedOfferContext);
};
